import { render, staticRenderFns } from "./BlogSlider.vue?vue&type=template&id=680844c8&scoped=true&lang=html"
import script from "./BlogSlider.vue?vue&type=script&lang=js"
export * from "./BlogSlider.vue?vue&type=script&lang=js"
import style0 from "./BlogSlider.vue?vue&type=style&index=0&id=680844c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680844c8",
  null
  
)

export default component.exports